import { useState } from "react";
import { dryAlphaGroups } from "@/mocks/dryalpha";

interface Section {
  anchor: string;
  title: string;
  html: string;
}

const allSections: Section[] = dryAlphaGroups.flatMap((g) => g.sections);

export default function DryAlphaFeature() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleSection = (idx: number) => {
    const willOpen = openIndex !== idx;

    if (willOpen) {
      const scrollY = window.scrollY;
      setOpenIndex(idx);
      requestAnimationFrame(() => {
        window.scrollTo({ top: scrollY, behavior: "auto" });
      });
    } else {
      setOpenIndex(null);
    }
  };

  return (
    <section className="py-12 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center">
          ドライアルファ特集
        </h2>
        <p className="text-center text-foreground-600 text-sm md:text-base mb-10 -mt-4">
          全11項目の研究レポート。各項目をクリックすると詳細が表示されます。
        </p>

        <div className="space-y-3">
          {allSections.map((section, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={section.anchor}
                id={section.anchor}
                className="rounded-lg overflow-hidden border border-background-200/70 transition-colors"
              >
                <button
                  type="button"
                  onClick={() => toggleSection(idx)}
                  className="w-full flex items-center gap-4 px-5 py-4 text-left bg-background-100 hover:bg-background-200/60 transition-colors cursor-pointer group"
                >
                  <span className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xs font-bold">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <span className="flex-1 text-sm md:text-base font-semibold text-foreground-900 group-hover:text-foreground-950 transition-colors">
                    {section.title}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-300 flex-shrink-0 ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>

                <div
                  className={`grid transition-[grid-template-rows] duration-300 ease-in-out ${
                    isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className="px-5 md:px-8 py-5 md:py-6 bg-background-50 border-t border-background-200/70">
                      <div
                        className="dryalpha-content text-foreground-800 text-sm md:text-base leading-relaxed"
                        dangerouslySetInnerHTML={{ __html: section.html }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}